import ContainerGraphs from '../Graphics/Sections/ContainerGraphs';
import { IIndicator } from '../../../../interfaces/Indicator';
import HeaderIndicator from './HeaderIndicator';
import FooterIndicator from './FooterIndicator';
import CTABox from '../../../../components/Cards/CTABox';
import { MdArrowForward } from 'react-icons/md';
import NoGraphics from '../Graphics/Sections/NoGraphics';

const Indicator = ({ breadcrumbs, titulo, state, descripcion, notas, fuente, graphics, data, documento_informativo, investigaciones, id, ods, grupos_prioritarios, subdimension, dimension, capa_mapa }: IIndicator) => {
  
    return (
        <div className='flex flex-col gap-6 border-b-2 w-full border-[#DCE4E9] pb-8 mt-8'>
            <HeaderIndicator
                breadcrumbs={breadcrumbs}
                titulo={titulo}
                state={state}
                descripcion={descripcion}
                notas={notas}
                documento_informativo={documento_informativo}
                id={id || 0}
                ods={ods}
                priorityGroups={grupos_prioritarios}
                dimension={dimension}
                subdimension={subdimension}
            />
            {
                graphics && graphics.length > 0 ?
                    <ContainerGraphs
                        breadcrumbs={breadcrumbs}
                        graphics={graphics}
                        source={fuente ?? ''}
                        name_indicator={titulo}
                        data={data ?? []}
                        mapLayer={capa_mapa || []}
                    />
                    : <NoGraphics />
            }
            {fuente &&
                <FooterIndicator
                    fuente={fuente}
                />}
            {
                investigaciones && investigaciones.length > 0 ?
                    <CTABox
                        title="Informes relacionados"
                        linkPath={`/monitor/informes?related_indicator_id=${id}&related_indicator_title=${titulo}`}
                        buttonLabel="Conocer"
                        buttonIcon={MdArrowForward}
                        background="bg-brand-green-5"
                        classNameContainer='m-0'
                        buttonVariant='outline-orange'
                        buttonClassName='bg-primary-100'
                    /> : null
            }
        </div>
    )
}

export default Indicator